import {
  getCurrencyByCultureCountry,
  getFormatDateByCultureCountry,
  getMileageUnitByCultureCountry
} from '@openflex/component'
import getCultureCountry from './country'

export const getCurrency = () => getCurrencyByCultureCountry(getCultureCountry())
export const getMileageUnit = (extended = false) =>
  getMileageUnitByCultureCountry(getCultureCountry(), extended)
export const getFormatDate = () => getFormatDateByCultureCountry(getCultureCountry())
